const initialState = {
  institution: null,
  version: null,
  files: [],
  isValid: false,
  defaultGroup: null,
  defaultDueDate: null
}

const actionTypes = {
  setInstitution: 'setInstitution',
  setVersion: 'setVersion',
  changeDefaultGroup: 'changeDefaultGroup',
  changeDefaultDueDate: 'changeDefaultDueDate',
  add: 'add',
  remove: 'remove',
  changeDueDate: 'changeDueDate',
  changeGroup: 'changeGroup',
  rename: 'rename',
  resetState: 'resetState'
}

function reducer (state = initialState, action) {
  let newState = null

  switch (action.type) {
    case actionTypes.setInstitution:
      newState = { ...state, institution: action.data }
      break
    case actionTypes.setVersion:
      newState = { ...state, version: action.data }
      break
    case actionTypes.add:
      newState = { ...state, files: [ ...state.files, { ...action.data, groupId: state.defaultGroup, dueDate: state.defaultDueDate } ] }
      break
    case actionTypes.remove:
      newState = { ...state, files: state.files.filter(x => x.id !== action.data) }
      break
    case actionTypes.changeGroup:
      newState = {
        ...state,
        files: editFileProp(state.files, action.data.id, 'groupId', action.data.groupId)
      }
      break
    case actionTypes.changeDueDate:
      newState = {
        ...state,
        files: editFileProp(state.files, action.data.id, 'dueDate', action.data.dueDate)
      }
      break
    case actionTypes.rename:
      newState = {
        ...state,
        files: editFileProp(state.files, action.data.id, 'name', action.data.newName)
      }
      break
    case actionTypes.resetState: return { ...initialState }
    case actionTypes.changeDefaultGroup: return { ...state, defaultGroup: action.data }
    case actionTypes.changeDefaultDueDate: return { ...state, defaultDueDate: action.data }
  }

  newState.isValid = validateState(newState)
  return newState
}

const validateState = (state) => {
  if (!state.files.length) return false

  let isValid = true

  state.files.forEach(x => {
    if (!x.groupId) isValid = false
    if (!x.name) isValid = false
    if (!x.dueDate) isValid = false
  })

  return isValid
}

const editFileProp = (files, id, propName, propValue) => {
  let item
  let index

  files.forEach((file, fileIndex) => {
    if (file.id === id) {
      item = { ...file }
      item[propName] = propValue
      index = fileIndex
    }
  })

  if (!item) return files

  const array = [ ...files.filter(x => x.id !== id) ]

  array.splice(index, 0, item)

  return array
}

export {
  initialState,
  actionTypes,
  reducer
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/inputReportsGenerator/reducer.js